/** Helpers for moving between views inside whichever role dashboard the user is in. */

const ROLES = ["groover", "creator", "venue"] as const;

export function currentRole(pathname = window.location.pathname): (typeof ROLES)[number] {
  const found = ROLES.find((r) => pathname.includes(`/dashboard/${r}`));
  return found ?? "groover";
}

/** Path to another view in the dashboard the user is currently browsing. */
export function dashboardPath(view: string, pathname = window.location.pathname): string {
  return `/dashboard/${currentRole(pathname)}/${view}`;
}
